import { GridHeaders } from '@project-types/GridHeaders';
import { ShipmentStopsGridData } from '@pages/reporting-pages/shipment-stops/types/ShipmentStopsGridData';



export const headersObject: GridHeaders<ShipmentStopsGridData> = [
	{ label: 'Zákazník', key: 'customerSapId', width: '1fr' },
	{ label: 'Název', key: 'customerName', width: '4fr' },
	{ label: 'Město', key: 'city', width: '4fr' },
	{ label: 'Ulice', key: 'street', width: '2fr' },
	{ label: 'Obchodník', key: 'salesMan', width: '3fr' },
	{ label: 'Plánovaný příjezd a odjezd', key: 'plannedTimes', width: '2fr' },
	{ label: 'Skutečný příjezd a odjezd', key: 'realTimes', width: '2fr' },
]